import React from 'react';
import { useTranslation } from 'react-i18next';
import './error-warning.scss';
import { Button, Icon } from '@socialchorus/shared-ui-components';

/**
 * Props for the ErrorWarning component
 */
interface ErrorWarningProps {
  /**
   * Title of the error message
   */
  title?: string;
  /**
   * Description of the error message
   */
  description?: string;
  /**
   * URL for the support status link
   */
  supportStatusUrl?: string;
}

/**
 * ErrorWarning component - Displays an error message with an icon and support link
 * Used to show content unavailability or other system errors
 */
const ErrorWarning: React.FC<ErrorWarningProps> = ({ title, description }) => {
  const { t } = useTranslation();
  const supportStatusLink = 'https://status.firstup.io/';

  return (
    <div className="error-warning">
      <div className="error-warning__container">
        <Icon size={40}>warning</Icon>
        <h2 className="error-warning__title">
          {title || t('errors.content_unavailable')}
        </h2>
        <p className="error-warning__description">
          {description || t('errors.try_refreshing')}
        </p>
        #
        <Button
          size="default"
          rightIcon={<Icon>open_in_new</Icon>}
          label={t('errors.support_status')}
          variant={'text'}
          href={supportStatusLink}
          target="_blank"
          rel="noopener noreferrer"
        />
      </div>
    </div>
  );
};

export default ErrorWarning;
